// extracted by mini-css-extract-plugin
module.exports = {"bodyHasCarrotquestWidget":"_3K1xjWrClTmGHcSSXY2N_n"};